import { MANUAL_ENTRY } from './CompanySearchItem.constants';
import { CompanySearchOption } from './CompanySearchItem.types';

export const getCompanySearchOptionKey = (item: CompanySearchOption): string =>
  item === MANUAL_ENTRY
    ? MANUAL_ENTRY
    : `${item.source}-${item.registrationNumber}`;
